import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React from "react";

export function SaveIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48">
      <circle
        style={{
          fill: "none",
          stroke: "currentcolor",
          strokeWidth: 3.6703,
          strokeMiterlimit: 10,
        }}
        cx="24"
        cy="24.04"
        r="22.02"
      />
      <path
        d="M32.51,27.84c-0.63,0-1.14-0.52-1.14-1.15V9.49c0-0.63-0.51-1.14-1.14-1.14H17.76c-0.63,0-1.14,0.51-1.14,1.14v17.12
		c0,0.63-0.51,1.14-1.14,1.13l-4.02-0.02c-0.63,0-0.77,0.35-0.33,0.79l12.13,11.93c0.45,0.44,1.18,0.44,1.62,0l11.96-11.76
		c0.45-0.44,0.3-0.8-0.33-0.81L32.51,27.84z"
      />
    </SvgIcon>
  );
}
